import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  branchList: [],
  selectedBranchId: null,
};

// Slice
const getBranchesStoreNewsSlice = createSlice({
  name: "getBranchesStoreNews",
  initialState,
  reducers: {
    findBranches() {},
    initBranches(state) {
      return {
        ...state,
        loading: false,
        loaded: null,
        data: null,
        branchList: [],
        selectedBranchId: null,
        tel: null,
      };
    },
    setBranches(state, action) {
      const { branchList } = action.payload;
      return { ...state, branchList };
    },
    setBranchId(state, action) {
      const { selectedBranchId } = action.payload;
      return { ...state, selectedBranchId };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  findBranches,
  initBranches,
  setBranches,
  setBranchId,
  fetchDataSuccess,
  fetchDataFailure,
} = getBranchesStoreNewsSlice.actions;

export default getBranchesStoreNewsSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data = {} } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { resultCode, storeList } = response.data;

      if (resultCode === "0000") {
        yield put(setBranches({ branchList: storeList }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* getBranchesStoreNewsSaga() {
  yield takeLatest(findBranches.type, fetchDataSaga);
}
